import { render, staticRenderFns } from "./IotDeviceDeleteDialog.vue?vue&type=template&id=1983e532&scoped=true"
import script from "./IotDeviceDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./IotDeviceDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./IotDeviceDeleteDialog.vue?vue&type=style&index=0&id=1983e532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1983e532",
  null
  
)

export default component.exports